module.exports = __webpack_public_path__ + "static/media/about.4ec28b65.png";